
const getFormConfig = () => {
  return {
    enrolledFilters: [
      [
        {
          name: 'First_Name',
          type: 'text',
          placeholder: 'Filters.Enrolled.FirstName.Placeholder',
          searchButton: true,
          wrapperClasses: 'field-with-icon field-grey-steel',
        },
        {
          name: 'Preferred_Name',
          type: 'text',
          placeholder: 'Filters.Enrolled.PreferredName.Placeholder',
          searchButton: true,
          wrapperClasses: 'field-with-icon field-grey-steel',
        },
        {
          name: 'Last_Name',
          type: 'text',
          placeholder: 'Filters.Enrolled.LastName.Placeholder',
          searchButton: true,
          wrapperClasses: 'field-with-icon field-grey-steel',
        },
        {
          name: 'Term_Label',
          type: 'select',
          placeholder: 'Filters.Enrolled.Select.Term.Placeholder',
          isMulti: true,
        },
        {
          name: 'Program_Localized_Name',
          type: 'select',
          placeholder: 'Filters.Enrolled.Select.Program.Placeholder',
          isMulti: true,
        },
        {
          name: 'Student_Status_Type',
          type: 'select',
          placeholder: 'Filters.Enrolled.Select.Status.Placeholder',
          isMulti: true,
        },
      ],
      [
        {
          name: 'programType',
          type: 'radios',
          options: [
            {
              value: 'standard',
              label: 'Filters.Enrolled.Radio.Type.Basic',
            },
            {
              value: 'internships',
              label: 'Filters.Enrolled.Toggle.Internship'
            },
            {
              value: 'customized',
              label: 'Filters.Enrolled.Radio.Type.Customized'
            },
          ],
          wrapperClasses: 'flex flex-col lg:flex-row gap-x-20 relative z-10 lg:mb-20 xl:mb-0',
        }
      ],
      [
        {
          name: 'School_Of_Record',
          type: 'toggle',
          label: 'Filters.Enrolled.Toggle.SOR',
          trueValue: 'Y',
          falseValue: '',
          tooltip: 'Filters.Enrolled.Toggle.SOR.Tooltip',
        }
      ],
    ],
    pendingFilters: [
      [
        {
          name: 'First_Name',
          type: 'text',
          placeholder: 'Filters.Enrolled.FirstName.Placeholder',
          searchButton: true,
          wrapperClasses: 'field-with-icon',
        },
        {
          name: 'Last_Name',
          type: 'text',
          placeholder: 'Filters.Enrolled.LastName.Placeholder',
          searchButton: true,
          wrapperClasses: 'field-with-icon',
        },
        {
          name: 'Preferred_Name',
          type: 'text',
          placeholder: 'Filters.Enrolled.PreferredName.Placeholder',
          searchButton: true,
          wrapperClasses: 'field-with-icon field-grey-steel',
        },
        {
          name: 'Term_Label',
          type: 'select',
          placeholder: 'Filters.Enrolled.Select.Term.Placeholder',
          isMulti: true,
        },
        {
          name: 'Program_Localized_Name',
          type: 'select',
          placeholder: 'Filters.Enrolled.Select.Program.Placeholder',
          isMulti: true,
        },
      ],
      [
        {
          name: 'programType',
          type: 'radios',
          options: [
            {
              value: 'standard',
              label: 'Filters.Enrolled.Radio.Type.Basic',
              checked: true
            },
            {
              value: 'internships',
              label: 'Filters.Enrolled.Toggle.Internship'
            },
            {
              value: 'customized',
              label: 'Filters.Enrolled.Radio.Type.Customized'
            },
          ],
          wrapperClasses: 'flex flex-col lg:flex-row gap-x-20 relative z-10',
        }
      ],
    ],
    missingDocsFilters: [
      [
        {
          name: 'First_Name',
          type: 'text',
          placeholder: 'Filters.Enrolled.FirstName.Placeholder',
          searchButton: true,
          wrapperClasses: 'field-with-icon field-grey-steel',
        },
        {
          name: 'Last_Name',
          type: 'text',
          placeholder: 'Filters.Enrolled.LastName.Placeholder',
          searchButton: true,
          wrapperClasses: 'field-with-icon field-grey-steel',
        },
        {
          name: 'Preferred_Name',
          type: 'text',
          placeholder: 'Filters.Enrolled.PreferredName.Placeholder',
          searchButton: true,
          wrapperClasses: 'field-with-icon field-grey-steel',
        },
        {
          name: 'Term_Label',
          type: 'select',
          placeholder: 'Filters.Enrolled.Select.Term.Placeholder',
          isMulti: true,
        },
        {
          name: 'Program_Localized_Name',
          type: 'select',
          placeholder: 'Filters.Enrolled.Select.Program.Placeholder',
          isMulti: true,
        },
      ],
      [
        {
          name: 'programType',
          type: 'radios',
          options: [
            {
              value: 'standard',
              label: 'Filters.Enrolled.Radio.Type.Basic',
            },
            {
              value: 'internships',
              label: 'Filters.Enrolled.Toggle.Internship'
            },
            {
              value: 'customized',
              label: 'Filters.Enrolled.Radio.Type.Customized'
            },
          ],
          wrapperClasses: 'flex flex-col lg:flex-row gap-x-20 relative z-10',
        }
      ],
    ],
    ambassadorsFilters: [
      [
        {
          name: 'First_Name',
          type: 'text',
          placeholder: 'Filters.Enrolled.FirstName.Placeholder',
          searchButton: true,
          wrapperClasses: 'field-with-icon',
        },
        {
          name: 'Last_Name',
          type: 'text',
          placeholder: 'Filters.Enrolled.LastName.Placeholder',
          searchButton: true,
          wrapperClasses: 'field-with-icon',
        },
        {
          name: 'Preferred_Name',
          type: 'text',
          placeholder: 'Filters.Enrolled.PreferredName.Placeholder',
          searchButton: true,
          wrapperClasses: 'field-with-icon field-grey-steel',
        },
        {
          name: 'Program_Localized_Name',
          type: 'select',
          placeholder: 'Filters.Enrolled.Select.Program.Placeholder',
          isMulti: true,
        },
      ],
      [
        {
          name: 'programType',
          type: 'radios',
          options: [
            {
              value: 'standard',
              label: 'Filters.Enrolled.Radio.Type.Basic',
              checked: true
            },
            {
              value: 'internships',
              label: 'Filters.Enrolled.Toggle.Internship'
            },
            {
              value: 'customized',
              label: 'Filters.Enrolled.Radio.Type.Customized'
            },
          ],
          wrapperClasses: 'flex flex-col lg:flex-row gap-x-20 relative z-10',
        }
      ],
    ],
    programFinderQuery: {
      name: 'query',
      type: 'text',
      placeholder: 'ProgramFinder.Query.Placeholder',
      clearButton: true,
    },
    programFinderSidebar: [
      {
        name: 'field_prgm_type',
        type: 'radios',
        label: 'ProgramFinder.SidebarFilters.PrgmType.Label',
        dataLayerCallback: 'filterSelected',
      },
      {
        name: 'field_prgm_options',
        type: 'checkboxes',
        label: 'ProgramFinder.SidebarFilters.PrgmOpt.Label',
        dataLayerCallback: 'filterSelected',
      },
      {
        name: 'field_prgm_disciplines',
        type: 'select',
        label: 'ProgramFinder.SidebarFilters.PrgmDisc.Label',
        placeholder: 'ProgramFinder.SidebarFilters.Select.Placeholder',
        isMulti: true,
        dataLayerCallback: 'filterSelected',
        wrapperClasses: 'sidebar-select',
      },
      {
        name: 'regions',
        type: 'radios',
        label: 'ProgramFinder.SidebarFilters.Regions.Label',
        dataLayerCallback: 'filterSelected',
      },
      {
        name: 'destinations',
        type: 'select',
        label: 'ProgramFinder.SidebarFilters.Destinations.Label',
        placeholder: 'ProgramFinder.SidebarFilters.Select.Placeholder',
        callback: 'createDestinationHierarchy',
        isMulti: true,
        dataLayerCallback: 'filterSelected',
        wrapperClasses: 'sidebar-select',
      },
      {
        name: 'field_prgm_term_type',
        type: 'checkboxes',
        label: 'ProgramFinder.SidebarFilters.TermType.Label',
        dataLayerCallback: 'filterSelected',
        callback: 'sortTerms',
      },
      {
        name: 'field_prgm_lang_pre_lvl',
        type: 'checkboxes',
        label: 'ProgramFinder.SidebarFilters.LangPre.Label',
        labelTooltip: 'ProgramFinder.SidebarFilters.LangPre.Label.Tooltip',
        dataLayerCallback: 'filterSelected',
      },
      {
        name: 'field_prgm_lang_instruct',
        type: 'select',
        label: 'ProgramFinder.SidebarFilters.LangInstr.Label',
        placeholder: 'ProgramFinder.SidebarFilters.Select.Placeholder',
        isMulti: true,
        dataLayerCallback: 'filterSelected',
        wrapperClasses: 'sidebar-select',
      },
      {
        name: 'field_prgm_housing_opt',
        type: 'checkboxes',
        label: 'ProgramFinder.SidebarFilters.Housing.Label',
        dataLayerCallback: 'filterSelected',
      },
      {
        name: 'price_range',
        type: 'range',
        min: -1,
        max: 30000,
        label: 'ProgramFinder.SidebarFilters.PriceRange.Label',
        dataLayerCallback: 'filterSelected',
        disableMin: true,
      }
    ],
    searchQuery: {
      name: 'query',
      type: 'text',
      clearButton: true,
    },
    searchSidebar: [
      {
        name: 'entity_type_label',
        type: 'checkboxes',
        label: 'GlobalSearch.SidebarFilters.PrgmType.Label',
        dataLayerCallback: 'filterSelected',
      },
    ],
    globalSearchItemsPerPage: [
      {
        name: 'itemsPerPage',
        type: 'sortSelect',
        label: 'GlobalSearch.ItemsPerPage.Label',
        options: [
          {
            label: '10',
            value: 10,
          },
          {
            label: '15',
            value: 15,
          },
          {
            label: '20',
            value: 20,
          },
        ],
      },
    ]
  };
};

export default getFormConfig;
